import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IScanTrayData, IScanTrayPayload } from '../../../types';

/**
 * This is to track the mutation key for scanning a tray
 */
const MUT_SCAN_TRAY = 'scan-tray-mutation';

interface IScanTrayMutationParam {
  onSuccess: (data: IScanTrayData, variables: IScanTrayPayload) => void;
  onError: (err: IApiError) => void;
}

/**
 * React Query mutation function for scanning tray after adding a package to
 * the tray.
 */
export const useScanTrayMutation = ({
  onSuccess,
  onError,
}: IScanTrayMutationParam) => {
  const { isPending, isError, error, data, mutate, reset } = useMutation({
    mutationKey: [MUT_SCAN_TRAY],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.scanTray,
    onSuccess,
    onError,
  });

  return {
    data,
    isScanTrayError: isError,
    isScanTrayOngoing: isPending,
    resetScanTray: reset,
    scanTray: mutate,
    scanTrayError: error,
  };
};
